











import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import moment from 'moment';

export interface Time {
  hours: number;
  minutes: number;
}

@Component
export default class UiInputTime extends Vue {
  @Prop()
  value: string;

  @Prop({default: '00:00'})
  default: string;

  @Prop({default: '##:##'})
  mask: string;

  @Prop()
  min: string;

  @Prop()
  max: string;

  @Prop()
  minutesAttractor: number[];

  getTime(value: string): Time {
    let match = value.match(this.timeRegex);
    if(match) {
      let hours: number = +match[1];

      if(hours > 23) {
        hours = 23;
      } else if(hours < 0) {
        hours = 0;
      }

      let minutes: number = +match[2];

      if(this.minutesAttractor) {
        let minValue = Number.MAX_SAFE_INTEGER;
        let attractor = minutes;

        for(let newAttractor of this.minutesAttractor) {
          let newMinValue = Math.abs(minutes - newAttractor);
          if(newMinValue  < minValue) {
            attractor = newAttractor;
            minValue = newMinValue;
          }
        }

        minutes = attractor;
      }

      if(minutes > 59) {
        minutes = 59;
      } else if(minutes < 0) {
        minutes = 0;
      }

      return {
        hours: hours,
        minutes: minutes
      };
    }

    return null;
  }

  @Watch('value', { immediate: true })
  onValueChanged(value: string) {
    if(this.timeRegex.test(value)) {
      this.pValue = value;
    } else {
      this.$emit('input', this.default);
    }
  }

  isMinMaxConstraint(value: string) {
    const minCond = this.min && value < this.min;
    const maxCond = this.max && value > this.max;
    
    return minCond || maxCond;
  }

  get isValueMinMaxConstraint() {
    return this.isMinMaxConstraint(this.value);
  }

  @Watch('isValueMinMaxConstraint')
  onIsValueMinMaxConstraintChanged(value: boolean) {
    if(value) {
      this.$emit('input', this.default);
    }
  }

  pValue: string = '';

  get timeRegex() {
    return /^(\d{1,2}):(\d{1,2})$/;
  }

  handleBlur() {
    this.processValue();
  }

  processValue() {
    const time = this.getTime(this.pValue);

    if(time) {
      const result = moment(`${time.hours}:${time.minutes}`, 'HH:mm').format('HH:mm');

      this.pValue = result;
      this.$emit('input', this.pValue); 
    } else {
      this.pValue = this.value;
    }
  }
}
